import { themeObject } from '../../../../lib';

export const anchorPoint: 'top' | 'left' | 'bottom' | 'right' | undefined =
    'right';

export interface NodeDetailDrawerProps {
    isOpen: boolean;
    data: any;
    setDrawerOpen: Function;
    nodeColors: Record<string, string>;
}

export interface LinkDetailsProps {
    label: string;
    from: string;
    to: string;
    id: string;
    autoEdge: boolean;
    timestamp: string;
    properties?: Record<string, any>;
}

export const nodeDetailDrawerStyles = {
    detailsDrawer: {
        minWidth: '570px',
    },
    detailsContainer: {
        width: '510px',
    },
    nodeColorContainer: {
        margin: '7px 7px 0 8px',
    },
    titleContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    titleStyle: {
        fontFamily: 'Raleway',
        fontWeight: '500',
        fontSize: '24px',
        lineHeight: '28.18px',
        color: themeObject.palette.primary[700],
        fontVariantNumeric: 'lining-nums',
    },
    subheaderStyle: {
        fontFamily: 'Source Code Pro',
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '17.6px',
        letter: '0.5px',
        color: themeObject.palette.grayScale[700],
    },
    nodeColor: {
        borderRadius: '10px',
        height: '14px',
        width: '14px',
    },
};
